import { render, staticRenderFns } from "./bingo-card.vue?vue&type=template&id=0cc1abae&"
import script from "./bingo-card.vue?vue&type=script&lang=js&"
export * from "./bingo-card.vue?vue&type=script&lang=js&"
import style0 from "./bingo-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports